import { render, staticRenderFns } from "./distincted-list.vue?vue&type=template&id=bcbd25b8&"
import script from "./distincted-list.vue?vue&type=script&lang=js&"
export * from "./distincted-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports